module.exports = __webpack_public_path__ + "videos/mts-products-chats-ai-assistant.de95b64.webm";